var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearchIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5545 11.8054L16.5004 16.75M13.4996 7.25C13.4996 10.5637 10.8133 13.25 7.49963 13.25C4.18593 13.25 1.49963 10.5637 1.49963 7.25C1.49963 3.93629 4.18593 1.25 7.49963 1.25C10.8133 1.25 13.4996 3.93629 13.4996 7.25Z",
    stroke: "#8B959A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "search-icon.7a3c9a4af059d1302d454c605a5e25d7.svg";